import type { ILeaveFormula, IPublicHolidays, IResource, IResourceRecruitmentDate } from '../../interface/src/index.ts'
import { getJobInPeriod, getResourceLOA } from '../../resource/src/index.ts'
import {workingDaysBetweenDates, holidaysBetweenDates} from '../../common/src/index.ts'

// LeaveFormula

const countMonths = (date1: Date | string, date2: Date | string): number => {
  const d1 = new Date(date1)
  const d2 = new Date(date2)
  d1.setDate(1)
  d1.setDate(d1.getDate() - 1)
  d2.setDate(1)
  d2.setMonth(d2.getMonth() + 1)
  let months
  months = (d2.getFullYear() - d1.getFullYear()) * 12
  months -= d1.getMonth() + 1
  months += d2.getMonth()
  return months <= 0 ? 0 : months
}

const getDaysInYear = (year: number) => {
  return new Date(year, 0, 1).getFullYear() % 4 == 0 ? 366 : 365
}

const getWeekendDaysInYear = (year: number) => {
  const fromDate = new Date(year, 0, 1)
  const toDate = new Date(year, 11, 31)
  let weekendDayCount = 0
  while (fromDate < toDate) {
    fromDate.setDate(fromDate.getDate() + 1)
    if (fromDate.getDay() === 0 || fromDate.getDay() == 6)
      ++weekendDayCount
  }

  return weekendDayCount

}

// Fonction utilitaire : vérifie si un jour est ouvré
  const isBusinessDay = (date: Date, publicHolidays:(string | Date)[]) => {
    const day = date.getDay(); // 0=dimanche, 6=samedi
    const isWeekend = (day === 0 || day === 6);
    const isHoliday = publicHolidays.some(
      (h) =>
        new Date(h).getFullYear() === date.getFullYear() &&
        new Date(h).getMonth() === date.getMonth() &&
        new Date(h).getDate() === date.getDate()
    );
    return !isWeekend && !isHoliday;
  };
  
// Fonction utilitaire : compte les jours ouvrés dans un intervalle
const countBusinessDays = (start: Date, end: Date, publicHolidays:(string | Date)[]) => {
    let count = 0;
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      if (isBusinessDay(d, publicHolidays)) count++;
    }
    return count;
};

export const firstMonthRatioCalendar = function(user:Pick<IResourceRecruitmentDate, 'earliestStartDate' | 'recruitmentDate' | 'departureDate'>, year:number, month:number, daysAcquired:number){
    const earliestStartDate = new Date(user.earliestStartDate || user.recruitmentDate);
    const nbDaysInMonth = new Date(year, month + 1, 0).getDate();
    const daysRatio = (nbDaysInMonth - new Date(earliestStartDate).getDate() + 1) / nbDaysInMonth;
    const result = daysRatio * 1 * (daysAcquired / 12);
    return result;

}
export const lastMonthRatioCalendar = function(user:Pick<IResourceRecruitmentDate, 'recruitmentDate' | 'departureDate'>, year:number, month:number, daysAcquired:number){
  if (user.departureDate) {
    const nbDaysInMonth = new Date(year, month + 1, 0).getDate();
    const daysRatio = new Date(user.departureDate).getDate() / nbDaysInMonth;
    const result = daysRatio * 1 * (daysAcquired / 12);
    return result;
  };
  return 0;
}

export const firstMonthRatio30 = function(user:Pick<IResourceRecruitmentDate, 'earliestStartDate' | 'recruitmentDate' | 'departureDate'>, year:number, month:number, daysAcquired:number){
    const earliestStartDate = new Date(user.earliestStartDate || user.recruitmentDate);
    const nbDaysInMonth = new Date(year, month + 1, 0).getDate();
    const daysRatio = (nbDaysInMonth - new Date(earliestStartDate).getDate() + 1) / 30;
    const result = daysRatio * 1 * (daysAcquired / 12);
    return result;

}
export const lastMonthRatio30 = function(user:Pick<IResourceRecruitmentDate, 'recruitmentDate' | 'departureDate'>, year:number, month:number, daysAcquired:number){
  if (user.departureDate) {
    const nbDaysInMonth = new Date(year, month + 1, 0).getDate();
    const daysRatio = new Date(user.departureDate).getDate() / 30;
    const result = daysRatio * 1 * (daysAcquired / 12);
    return Math.ceil(result);
  };
  return 0;
}

export const firstMonthRatioBusiness = function(user:Pick<IResourceRecruitmentDate, 'recruitmentDate' | 'departureDate'>, year:number, month:number, daysAcquired:number, publicHolidays:(string | Date)[]){
            
    const recruitmentDate = new Date(user.recruitmentDate);
  
    // Début et fin du mois
    const startOfMonth = new Date(year, month, 1);
    const endOfMonth = new Date(year, month + 1, 0);

    // 1️⃣ Total de jours ouvrés dans le mois
    const totalBusinessDays = countBusinessDays(startOfMonth, endOfMonth, publicHolidays);
    const workedBusinessDays = countBusinessDays(recruitmentDate, endOfMonth, publicHolidays);

    // 3️⃣ Ratio
    const ratio = workedBusinessDays / totalBusinessDays;

    // 4️⃣ Application du ratio aux jours acquis
    const result = ratio * (daysAcquired / 12);

    return result;

}

export const lastMonthRatioBusiness = function(user:Pick<IResourceRecruitmentDate, 'recruitmentDate' | 'departureDate'>, year:number, month:number, daysAcquired:number, publicHolidays:(string | Date)[]){
    if (!user.departureDate) return 0;      
    
    const departureDate = new Date(user.departureDate);
  
    // Début et fin du mois
    const startOfMonth = new Date(year, month, 1);
    const endOfMonth = new Date(year, month + 1, 0);

    // Fonction utilitaire : vérifie si un jour est ouvré
    const isBusinessDay = (date: Date) => {
      const day = date.getDay(); // 0=dimanche, 6=samedi
      const isWeekend = (day === 0 || day === 6);
      const isHoliday = publicHolidays.some(
        (h) =>
          new Date(h).getFullYear() === date.getFullYear() &&
          new Date(h).getMonth() === date.getMonth() &&
          new Date(h).getDate() === date.getDate()
      );
      return !isWeekend && !isHoliday;
    };

    // Fonction utilitaire : compte les jours ouvrés dans un intervalle
    const countBusinessDays = (start: Date, end: Date) => {
      let count = 0;
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        if (isBusinessDay(d)) count++;
      }
      return count;
    };

    // 1️⃣ Total de jours ouvrés dans le mois
    const totalBusinessDays = countBusinessDays(startOfMonth, endOfMonth);
    // Worked from the start of the month up to the departure day, which is the last day worked
    const workedBusinessDays = countBusinessDays(startOfMonth, departureDate);

    // 3️⃣ Ratio
    const ratio = workedBusinessDays / totalBusinessDays;

    // 4️⃣ Application du ratio aux jours acquis
    const result = ratio * (daysAcquired / 12);

    return result;

}

export const LOARatioCalendar = function(year: number, month: number, user:Pick<IResource, 'jobs'>): number {
  let getJobThisMonth = getJobInPeriod(user, new Date(year, month, 1));
  if(!getJobThisMonth){ getJobThisMonth = getJobInPeriod(user, new Date(year, month+1, 0)); }

  // console.log('getJobThisMonth', new Date(year, month, 1), getJobThisMonth)
  if(!getJobThisMonth){ return 1; }

    return suspensionPeriodRatioCalendar(year, month, {startDate:new Date(getJobThisMonth.startDateLOA), endDate:new Date(getJobThisMonth.endDateLOA)});

}

export const LOARatioFullMonth = function(year: number, month: number, user:Pick<IResource, 'jobs'>): number {
  let getJobThisMonth = getJobInPeriod(user, new Date(year, month, 1));
  if(!getJobThisMonth){ getJobThisMonth = getJobInPeriod(user, new Date(year, month+1, 0)); }

  
  if(!getJobThisMonth){ return 1; }

  if(new Date(getJobThisMonth.startDateLOA).getMonth() == month && new Date(getJobThisMonth.startDateLOA).getFullYear() == year){
    return 1;
  }
  if(new Date(getJobThisMonth.endDateLOA).getMonth() == month && new Date(getJobThisMonth.endDateLOA).getFullYear() == year){
    return 1;
  }
  if(new Date(getJobThisMonth.startDateLOA) < new Date(year, month, 1) && new Date(getJobThisMonth.endDateLOA) > new Date(year, month, 0)){
    return 0;
  }
  
  return 1;

}

export const suspensionPeriodRatioCalendar = function(year: number, month: number, period?:{startDate:Date|string|null, endDate:Date|string|null}): number {
  
    if (!period || period.startDate == null || period.endDate == null) {
      return 1;
    }

    const startDate = new Date(period.startDate);
    const endDate = new Date(period.endDate);

    const daysInMonth = new Date(year, month + 1, 0).getDate(); // Nombre de jours dans le mois
    const firstDayOfMonth = new Date(year, month, 1); // Premier jour du mois
    const lastDayOfMonth = new Date(year, month, daysInMonth); // Dernier jour du mois

    // Vérifier si le mois est hors de la plage startDate - endDate
    if (endDate < firstDayOfMonth || startDate > lastDayOfMonth) {
        return 1; // Aucun jour n'est inclus dans l'intervalle
    }

    // Déterminer les limites du mois à prendre en compte
    const start = startDate > firstDayOfMonth ? startDate.getDate() : 1;
    const end = endDate < lastDayOfMonth ? endDate.getDate() : daysInMonth;
      
    return 1-(end - start + 1)/daysInMonth
}

export const getExcludedWeekDays = function(year: number, month: number, excludedDays?:{startDate:Date|string|null, endDate:Date|string|null, days:number}[]): number {
    if (!excludedDays || excludedDays.length === 0) {
      return 0;
    }

    const daysInMonth = excludedDays?.reduce((acc, p) => {
      if (!p.startDate || !p.endDate) return acc;
      const startDate = new Date(p.startDate);
      if (startDate.getFullYear() !== year || startDate.getMonth() !== month) return acc;
      return acc + p.days;
    }, 0) ?? 0;
    
    return daysInMonth;
}


export const yearlyAcquisition = (year:number, month:number, user:Pick<IResourceRecruitmentDate, 'earliestStartDate' | 'recruitmentDate' | 'departureDate' | 'jobs'>, publicHolidays:Date[], daysAcquired:number) => {
  const earliestStartDate = user.earliestStartDate ? new Date(user.earliestStartDate) : new Date(user.recruitmentDate);
  let isRecruitedThisYear = new Date(earliestStartDate).getFullYear()==year && new Date(earliestStartDate).getMonth()==month;
  let isDepartureThisYear = user.departureDate && new Date(user.departureDate).getFullYear()==year && new Date(user.departureDate).getMonth()>=month;
  

  const loaArray = getResourceLOA(user)
  let tempCurrentYear = new Date(year, month, 1)
  let isLOA = loaArray.find((loa) => {
    return (loa.startDate.getMonth() == month && loa.startDate.getFullYear() == tempCurrentYear.getFullYear())
      || (loa.endDate.getMonth() == month && loa.endDate.getFullYear() == tempCurrentYear.getFullYear())
      || (loa.startDate < new Date(year, 11, 1) && loa.endDate > new Date(year, 0, 1))
  })

  let removeLOADays = 0
    if (isLOA) {
      let startDateLOA = new Date(year, 0,1);
      let endDateLOA = new Date(year, 11, 31);
      if (new Date(isLOA.startDate)>startDateLOA) {startDateLOA = new Date(isLOA.startDate)};
      if (new Date(isLOA.endDate)<endDateLOA) {endDateLOA = new Date(isLOA.endDate)};
        
        let countMonths = new Date(endDateLOA).getMonth() - new Date(startDateLOA).getMonth() - 1;
        let daysRatioStartLOA = 0;
        let daysRatioEndLOA = 0;

        let LOACapacityRate = (getJobInPeriod(user, startDateLOA)?.rate||100)/100;

        if (startDateLOA.getDate()==1) {
              countMonths++
        }
        else{
          let workingDaysStartLOA = workingDaysBetweenDates(startDateLOA, new Date(new Date(startDateLOA).getFullYear(), new Date(startDateLOA).getMonth()+1,0))
          let holidaysStartLOA = holidaysBetweenDates(startDateLOA, new Date(new Date(startDateLOA).getFullYear(), new Date(startDateLOA).getMonth()+1,0), publicHolidays)
          let totalDaysStartLOA = workingDaysBetweenDates(new Date(new Date(startDateLOA).getFullYear(), new Date(startDateLOA).getMonth(),1), new Date(new Date(startDateLOA).getFullYear(), new Date(startDateLOA).getMonth()+1,0))
          let totalHolidaysStartLOA = holidaysBetweenDates(new Date(new Date(startDateLOA).getFullYear(), new Date(startDateLOA).getMonth(),1), new Date(new Date(startDateLOA).getFullYear(), new Date(startDateLOA).getMonth()+1,0), publicHolidays)
          daysRatioStartLOA = (workingDaysStartLOA-holidaysStartLOA)/(totalDaysStartLOA-totalHolidaysStartLOA);
        }
        if(new Date(new Date(endDateLOA).setDate(endDateLOA.getDate()+1)).getDate()){
              countMonths++
        }
        else{
          let workingDaysEndLOA = workingDaysBetweenDates(new Date(new Date(endDateLOA).getFullYear(), new Date(endDateLOA).getMonth(),1), endDateLOA)
          let holidaysEndLOA = holidaysBetweenDates(new Date(new Date(endDateLOA).getFullYear(), new Date(endDateLOA).getMonth(),1), endDateLOA, publicHolidays)
          let totalDaysEndLOA = workingDaysBetweenDates(new Date(new Date(endDateLOA).getFullYear(), new Date(endDateLOA).getMonth(),1), new Date(new Date(endDateLOA).getFullYear(), new Date(endDateLOA).getMonth()+1,0))
          let totalHolidaysEndLOA = holidaysBetweenDates(new Date(new Date(endDateLOA).getFullYear(), new Date(endDateLOA).getMonth(),1), new Date(new Date(endDateLOA).getFullYear(), new Date(endDateLOA).getMonth()+1,0), publicHolidays)
          daysRatioEndLOA = (workingDaysEndLOA-holidaysEndLOA)/(totalDaysEndLOA-totalHolidaysEndLOA);
        }

        removeLOADays = (countMonths + daysRatioStartLOA + daysRatioEndLOA) * daysAcquired/12 * LOACapacityRate;
    }
  
  if(isRecruitedThisYear){
      let workingDays = workingDaysBetweenDates(new Date(earliestStartDate), new Date(year, month+1,0))
      let holidays = holidaysBetweenDates(new Date(earliestStartDate), new Date(year, month+1,0), publicHolidays)
      let totalDays = workingDaysBetweenDates(new Date(year, month,1), new Date(year, month+1,0))
      let totalHolidays = holidaysBetweenDates(new Date(year, month,1), new Date(year, month+1,0), publicHolidays)
      let daysRatio = (workingDays-holidays)/(totalDays-totalHolidays);
  
      let recruitmentDateCapacityRate = (getJobInPeriod(user, new Date(earliestStartDate))?.rate||100)/100;
      
      if (user.departureDate && isDepartureThisYear) {
          let countMonths = new Date(user.departureDate).getMonth() - new Date(earliestStartDate).getMonth() - 1;
          let departureMonth = new Date(user.departureDate).getMonth();
          const departureDate = new Date(user.departureDate)
          const departureMonthDate = new Date(year, departureMonth,1)

          let workingDaysDeparture = workingDaysBetweenDates(departureMonthDate, departureDate)
          let holidaysDeparture = holidaysBetweenDates(new Date(year, departureMonth,1), departureDate, publicHolidays)

          let totalDaysDeparture = workingDaysBetweenDates(departureMonthDate, new Date(year, departureMonth+1,0))
          let totalHolidaysDeparture = holidaysBetweenDates(departureMonthDate, new Date(year, departureMonth+1,0), publicHolidays)
          let daysRatioDeparture = (workingDaysDeparture-holidaysDeparture)/(totalDaysDeparture-totalHolidaysDeparture);

          let departureDateCapacityRate = (getJobInPeriod(user, new Date(year, departureMonth,1))?.rate||100)/100;

                    let monthlyCapacityRate = 0;
                    for (var i = month+1; i < departureMonth; i++) {
                        monthlyCapacityRate += (getJobInPeriod(user, new Date(year, i, 1))?.rate||100);
                    };
                    monthlyCapacityRate = monthlyCapacityRate/(100*(departureMonth-month-1));
 
                    return countMonths*monthlyCapacityRate*daysAcquired/12 + (daysAcquired/12)*daysRatio*recruitmentDateCapacityRate + (daysAcquired/12)*daysRatioDeparture*departureDateCapacityRate - removeLOADays
      };

      let monthlyCapacityRate = 0;
      
                for (var i = month+1; i < 12; i++) {
                    monthlyCapacityRate += (getJobInPeriod(user, new Date(year, i, 1))?.rate||100);
                };
                monthlyCapacityRate = monthlyCapacityRate/(100*(12-month-1));
                
                return daysAcquired*(12-month-1)*monthlyCapacityRate/12 + (daysAcquired/12)*daysRatio*recruitmentDateCapacityRate - removeLOADays
  }
  else if(month==0){
      if (user.departureDate && isDepartureThisYear) {
          let countMonths = new Date(user.departureDate).getMonth() - month;
          let departureMonth = new Date(user.departureDate).getMonth();
          const departureDate = new Date(user.departureDate)

          let workingDaysDeparture = workingDaysBetweenDates(new Date(year, departureMonth,1), departureDate)
          let holidaysDeparture = holidaysBetweenDates(new Date(year, departureMonth,1), departureDate, publicHolidays)

          let totalDaysDeparture = workingDaysBetweenDates(new Date(year, departureMonth,1), new Date(year, departureMonth+1,0))
          let totalHolidaysDeparture = holidaysBetweenDates(new Date(year, departureMonth,1), new Date(year, departureMonth+1,0), publicHolidays)
          let daysRatioDeparture = (workingDaysDeparture-holidaysDeparture)/(totalDaysDeparture-totalHolidaysDeparture);
          
          let departureDateCapacityRate = (getJobInPeriod(user, new Date(year, departureMonth,1))?.rate||100)/100;
                    
          let monthlyCapacityRate = 0;
          for (var i = 0; i < departureMonth; i++) {
              monthlyCapacityRate += (getJobInPeriod(user, new Date(year, i, 1))?.rate||100);
          };
          monthlyCapacityRate = monthlyCapacityRate/(100*(departureMonth));

          return daysAcquired*(countMonths/12) * monthlyCapacityRate + (daysAcquired/12)*daysRatioDeparture*departureDateCapacityRate - removeLOADays
          
      }
      else if(getJobInPeriod(user, new Date(year, month, 1))===null){
        return 0;
      }
      else{
          let yearlyCapacityRate = 0;
          let countMonths = 0;
          for (var i = 0; i < 12; i++) {
              if (getJobInPeriod(user, new Date(year, i, 1))) {
                  yearlyCapacityRate += (getJobInPeriod(user, new Date(year, i, 1))?.rate||100);
                  countMonths++;    
              }
          };
          if(countMonths==0){return 0};
          yearlyCapacityRate = yearlyCapacityRate/1200;
          return daysAcquired*yearlyCapacityRate - removeLOADays;       
      }
      
  }
  else{
    return 0;
  }
};

export const leaveFormulas: Array<ILeaveFormula> = [
  {
    _id: 0,
    country: 'fr',
    display: 'RTT cadres',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: 'Acquisition mensuelle sur la base de calcul annuelle suivante : nombre de jours dans l\'année - (nombre de samedis + nombre de dimanches + nombre de jours fériés en semaine + 25 jours de congés payés + 218 jours travaillés)',
    formula(year, month, user, publicHolidays, options) {
      const daysInYear = getDaysInYear(year)
      const weekendDayCount = getWeekendDaysInYear(year)
      let publicHolidaysCount = 0
      for (let i = 0; i < publicHolidays.length; i++) {
        if (new Date(publicHolidays[i]).getDay() != 0 && new Date(publicHolidays[i]).getDay() != 6)
          publicHolidaysCount++
      };
      const daysPerYear = Math.round(1000 * 1 * (daysInYear - weekendDayCount - publicHolidaysCount - 25 - 218))/ 1000;

      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerYear);
      }  
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear);
      }

      return  daysPerYear / 12
    },
  },
  {
    _id: 1,
    country: 'fr',
    display: 'RTT non-cadres',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    description: '23 jours par an',
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    formula(year, month, user, publicHolidays, options) {
      const daysPerYear = 23;
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerYear);
      }  
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear);
      }
      return 1 * (daysPerYear / 12)
    },
  },
  {
    _id: 2,
    country: 'fr',
    display: 'Congés payés',
    isRemote: false,
    isManual: false,
    period: [6, 5],
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: '25 jours par an, soit 2.083 jours par mois',
    formula(year, month, user, publicHolidays, options) {
      const daysPerYear = 25;
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerYear);
      }  
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear);
      }
      return 1 * (daysPerYear / 12)
    },
  },
  {
    _id: 3,
    country: 'fr',
    display: 'Congés d\'ancienneté',
    isRemote: false,
    isManual: false,
    period: [6, 5],
    description: 'Acquisition le mois d\'anniversaire. 5 ans d\'ancienneté : 1 jour, 10 ans d\'ancienneté : 2 jours, 15 ans d\'ancienneté : 3 jours, 20 ans d\'ancienneté : 4 jours, 25 ans d\'ancienneté : 5 jours, 30 ans d\'ancienneté : 6 jours',
    formula(year, month, user, publicHolidays, options) {
      
      const months = countMonths(user.recruitmentDate, new Date(year, month+1, 0)) - 1
      const years = Math.floor(months / 12)
      var recruitementMonth = new Date(user.recruitmentDate).getMonth();

      return recruitementMonth==month?Math.floor(years/5):0;
    },
  },
  {
    _id: 4,
    country: 'fr',
    display: 'Absence exceptionnelle',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'Pas de formule, doivent être validés',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 5,
    country: 'fr',
    display: 'Travail à domicile',
    isRemote: true,
    isManual: true,
    period: [1, 12],
    description: 'Pas de formule, doivent être validés',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 6,
    country: 'ma',
    display: 'Congés payés avec ancienneté J-J',
    isRemote: false,
    isDay1Start: true,
    isManual: false,
    period: [7, 6],
    prorataFM:'Full month',
    prorataLM:'Full month',
    description: '1,75 jours par mois. Ancienneté : 5 ans : 1,5 jour, 10 ans : 3 jours, 15 ans : 4,5 jours, 20 ans : 6 jours, 25 ans : 7,5 jours, 30 ans : 9 jours',
    formula(year, month, user, publicHolidays, options) {

      const daysPerYear = 30;
      
      const months = countMonths(user.recruitmentDate, new Date(year, month+1, 0)) - 1
      const years = Math.floor(months / 12)
      const recruitementMonth = new Date(user.recruitmentDate).getMonth()
      const seniority = recruitementMonth == month ? (1.5 * Math.floor(((years - (years % 5)) / 5))) : 0

      // const LOARatio = LOARatioCalendar(year, month, user);
      const LOARatio = LOARatioFullMonth(year, month, user);

      return (1 * 1.75 + seniority) * LOARatio
    },
  },
  {
    _id: 7,
    country: 'ma',
    display: 'Absence exceptionnelle J-J',
    isDay1Start: true,
    isRemote: false,
    isManual: true,
    period: [7, 6],
    description: 'Pas de formule, doivent être validés',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 8,
    country: 'uk',
    display: 'Paid leave',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: '25 days per year (2.083 days per month)',
    formula(year, month, user, publicHolidays, options) {
      const daysPerYear = 25;
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerYear);
      }  
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear);
      }

      return 1 * (daysPerYear / 12)
    },
  },
  {
    _id: 9,
    country: 'uk',
    display: 'Exceptional absence',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'No formula, need to be validated',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 10,
    country: 'ma',
    display: 'Congés payés avec ancienneté mensuelle J-D. Formule modifiée 2025',
    isRemote: false,
    isDay1Start: true,
    isManual: false,
    period: [1, 12],
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: 'Avant 2025 : 21 jours par an, après 2025 : 25 jours par an. Ancienneté : 5 ans : 1,5 jour, 10 ans : 3 jours, 15 ans : 4,5 jours, 20 ans : 6 jours, 25 ans : 7,5 jours, 30 ans : 9 jours',
    formula(year, month, user, publicHolidays, options) {
      var daysPerYear = year<2025?21:25;
      
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerYear);
      } 
      const months = countMonths(user.recruitmentDate, new Date(year, month+1, 0)) - 1
      const years = Math.floor(months / 12)
      const seniority = ((years - (years % 5)) / 5)

      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear + seniority*1.5);
      }

      return 1 * daysPerYear/12 + seniority * (1.5 / 12)
    },
  },
  {
    _id: 11,
    country: 'ma',
    display: 'Congés payés stagiaire J-D',
    isRemote: false,
    isDay1Start: true,
    isManual: false,
    period: [1, 12],
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: '1,5 jours par mois',
    formula(year, month, user, publicHolidays, options) {
      const daysPerMonth = 1.5;
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerMonth*12);
      }  
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerMonth*12);
      }
      return 1 * daysPerMonth
    },
  },
  {
    _id: 12,
    country: 'ma',
    display: 'Absence exceptionnelle J-D',
    isDay1Start: false,
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'Pas de formule, doivent être validés',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 13,
    country: 'ma',
    display: 'Congés payés 25 jours avec ancienneté mensuelle J-D',
    isRemote: false,
    isDay1Start: true,
    isManual: false,
    period: [1, 12],
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: '2,083 jours par mois. Ancienneté : 5 ans : 1,5 jour, 10 ans : 3 jours, 15 ans : 4,5 jours, 20 ans : 6 jours, 25 ans : 7,5 jours, 30 ans : 9 jours',
    formula(year, month, user, publicHolidays, options) {
      const daysPerYear = 25;
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerYear);
      }
      const months = countMonths(user.recruitmentDate, new Date(year, month+1, 0)) - 1
      const years = Math.floor(months / 12)
      const seniority = ((years - (years % 5)) / 5)

      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear + seniority*1.5);
      }

      return 1 * (daysPerYear / 12) + seniority * (1.5 / 12)
    },
  },
  {
    _id: 14,
    country: 'ae',
    display: 'Annual leave',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    isDay1Start: true,
    yearLimitTransfer: 5,
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: '25 days per year (2.083 days per month). Acquisition on 1st day of month.',
    formula(year, month, user, publicHolidays, options) {
      const daysPerYear = 25;
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerYear);
      }  
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear);
      }
      return 1 * (daysPerYear / 12)
    },
  },
  {
    _id: 15,
    country: 'ae',
    display: 'Sick leave',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    isDay1Start: true,
    yearLimitTransfer: 0,
    description: '60 days per year',
    formula(year, month, user, publicHolidays, options) {
      const endOfYear = new Date(new Date().getFullYear() + 1, 0, 1)

      const contractStartDate = user.jobs.find(job => job.isStartDate)?.startDate||null;
      const leaveStartDate = new Date(contractStartDate||user.recruitmentDate);

      const months = countMonths(leaveStartDate, endOfYear) - 1

      if (months / 12 > 1) {
        if (month == 0)
          return 60

        else
          return 0
      }
      else {
        if (month == new Date(leaveStartDate).getMonth())
          return 60 * months / 12

        else
          return 0
      }
    },
  },
  {
    _id: 16,
    country: 'ae',
    display: 'Exceptional absence',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'No formula, need to be validated',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 17,
    country: 'es',
    display: 'Vacaciones',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    prorataFM:'If start date > 15 acquire 1 day, otherwise full acquisition',
    prorataLM:'Prorata based on calendar days',
    description: '26 days per year (2.16 days per month)',
    formula(year, month, user, publicHolidays, options) {
      const daysPerYear = 26;

      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        if (new Date(user.recruitmentDate).getDate() > 15)
          return 1
      }
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear);
      }

      const LOARatio = LOARatioCalendar(year, month, user);

      const suspensionRatio = suspensionPeriodRatioCalendar(year, month, options.period);
      
      return 1 * (daysPerYear/12) * LOARatio * suspensionRatio;

    },
  },
  {
    _id: 18,
    country: 'es',
    display: 'Exceptional absence',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'No formula, need to be validated',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 19,
    country: 'de',
    display: 'Leave',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    isDay1Start: true,
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: '30 days per year (2.5 days per month). Acquisition on 1st day of month.',
    formula(year, month, user, publicHolidays, options) {
      const daysPerYear = 30;
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerYear);
      }  
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear);
      }
      return 1 * (daysPerYear / 12)
    },
  },
  {
    _id: 20,
    country: 'de',
    display: 'Exceptional absence',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'No formula, need to be validated',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 21,
    country: 'de',
    display: 'Work from home absence',
    isRemote: true,
    isManual: true,
    period: [1, 12],
    description: 'No formula, need to be validated',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {_id:22, 
    country:'au', 
    display:'Annual leave hours', 
    isRemote:false, 
    isHours:true,
    isManual:false, 
    period:[1,12], 
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description:'152 hours per year (=20 days with 7.6 hours per day)',
      formula:function(year, month, user, publicHolidays, options){
        const hoursPerYear = 152;
        if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
          return firstMonthRatioCalendar(user, year, month, hoursPerYear);
        }  
        if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
          return lastMonthRatioCalendar(user, year, month, hoursPerYear);
        }

        const countWeekDaysInMonth = workingDaysBetweenDates(new Date(year, month, 1), new Date(year, month + 1, 0));
        const excludedDays = getExcludedWeekDays(year, month, options.excludedDays)
        const workedDays = countWeekDaysInMonth - excludedDays;
        const acquiredWorkedDays = workedDays * (20 * 7.6 / 52 / 5)

        return excludedDays===0 ? (hoursPerYear/12) : acquiredWorkedDays ;
      }
  },
  {
    _id: 23,
    country: 'au',
    display: 'Exceptional absence',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'No formula, need to be validated',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 24,
    country: 'ca',
    display: 'Congés payés',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: '25 jours par an, soit 2.083 jours par mois',
    formula(year, month, user, publicHolidays, options) {
      const daysPerYear = 25;
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerYear);
      }  
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear);
      }
      return 1 * (daysPerYear / 12)
    },
  },
  {
    _id: 25,
    country: 'ca',
    display: 'Absence exceptionnelle',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'Pas de formule, doivent être validés',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 26,
    country: 'fr',
    display: 'Demi-journée offerte',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    description: '1/2 jour si parmi les effectifs au 22/12, acquis en décembre',
    formula(year, month, user, publicHolidays, options) {
      if (month == 11 && getJobInPeriod(user, new Date(year, 11, 22)) !== null)
        return 0.5

      else
        return null
    },
  },
  {
    _id: 27,
    country: 'au',
    display: 'half-day free',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    description: '1/2 day if active on dec. 22nd, acquired in december',
    formula(year, month, user, publicHolidays, options) {
      if (month == 11 && getJobInPeriod(user, new Date(year, 11, 22)) !== null)
        return 0.5*7.6

      else
        return null
    },
  },
  {
    _id: 28,
    country: 'ca',
    display: 'Demi-journée offerte',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    description: '1/2 jour si parmi les effectifs au 22/12, acquis en décembre',
    formula(year, month, user, publicHolidays, options) {
      if (month == 11 && getJobInPeriod(user, new Date(year, 11, 22)) !== null)
        return 0.5

      else
        return null
    },
  },
  {
    _id: 29,
    country: 'nl',
    display: 'Statutory holidays',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: '20 days per year (1.66 days per month)',
    formula(year, month, user, publicHolidays, options) {
      const daysPerYear = 20;
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerYear);
      }  
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear);
      }
      return 1 * (daysPerYear / 12)
    },
  },
  {
    _id: 30,
    country: 'nl',
    display: 'Non statutory holidays',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: '10 days per year (1.66 days per month)',
    formula(year, month, user, publicHolidays, options) {
      const daysPerYear = 10;
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, daysPerYear);
      }  
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear);
      }
      return 1 * (daysPerYear / 12)
    },
  },
  {_id:31, 
    country:'ae', 
    display:'Annual leave yearly', 
    isRemote:false, 
    isManual:false, 
    period:[1,12], 
    isAcquiredYearly:true, 
    isDay1Start:true, 
    yearLimitTransfer:5, 
    roundUp:0.5, 
    prorataFM:'Prorata based on business days',
    prorataLM:'Prorata based on business days',
    description:'25 days per year. Acquisition on 1st day of year or based on prorata.',
    formula(year, month, user, publicHolidays, options){    
        const daysPerYear = 25;
          var result = yearlyAcquisition(year, month, user, publicHolidays.map(el=>new Date(el)), daysPerYear);
          return Math.ceil(result*2)/2;
      }
  },
  {_id:32, 
    country:'nl', 
    display:'Statutory holidays yearly', 
    isRemote:false, 
    isManual:false, 
    period:[1,12], 
    isAcquiredYearly:true, 
    roundUp:0.5, 
    prorataFM:'Prorata based on business days',
    prorataLM:'Prorata based on business days',
    description:'20 days per year Acquisition on 1st day of year or based on prorata.',
      formula(year, month, user, publicHolidays, options){
        const daysPerYear = 20;
        var result = yearlyAcquisition(year, month, user, publicHolidays.map(el=>new Date(el)), daysPerYear);
        return Math.ceil(result*2)/2;
      }
  },
  {_id:33, 
    country:'nl', 
    display:'Non statutory holidays yearly', 
    isRemote:false, 
    isManual:false, 
    period:[1,12], 
    isAcquiredYearly:true, 
    roundUp:0.5, 
    prorataFM:'Prorata calculated manualy',
    prorataLM:'Prorata calculated manualy',
    description:'10 days per year Acquisition on 1st day of year or based on prorata.',
      formula(year, month, user, publicHolidays, options){
        const daysPerYear = 10;
        var result = yearlyAcquisition(year, month, user, publicHolidays.map(el=>new Date(el)), daysPerYear); 
        return Math.ceil(result*2)/2;
      }
  },
  {_id:34, country:'fr', display:'JNT modifié en 2025 et 2026', isRemote:false, isManual:false, period:[1,12], isAcquiredYearly:true, description:'2024 : Acquisition annuelle proratisée au temps présent sur la base de calcul suivante : nombre de jours dans l\'année - (nombre de samedis + nombre de dimanches + nombre de jours fériés en semaine + 25 jours de congés payés + 218 jours travaillés - nombre de jours non travaillés). 2025 : sans jours non travaillés, 2026 : multiplié par le taux de présence',
      formula(year, month, user, publicHolidays, options){

          let daysInYear = getDaysInYear(year);
          let weekendDayCount = getWeekendDaysInYear(year);
          let publicHolidaysCount = 0;
          let daysWorked = 218;
          
          let rate = 100
          const job1 = getJobInPeriod(user, new Date(year, month, 1))
          const thisDate = new Date(year, month + 1, 1)
          thisDate.setDate(thisDate.getDate() - 1)

          const job2 = getJobInPeriod(user, thisDate)
          const job = job1 || job2
          if (job && job.rate && job.rate > 0){
            rate = job.rate
          }
            
          if (year<2025) {
            daysWorked = Math.round(daysWorked * rate/100);
          }
          

          for (var i = 0; i < publicHolidays.length; i++) {
              if (new Date(publicHolidays[i]).getDay()!=0 && new Date(publicHolidays[i]).getDay()!=6) {
                  publicHolidaysCount++;
              };
          };


        if(month==0){
          if (year>=2026) {
            return 1 * (rate/100) * Math.round(1000 * 1 * (daysInYear - weekendDayCount - publicHolidaysCount - 25 - daysWorked))/1000;    
          }
          return 1 * Math.round(1000 * 1 * (daysInYear - weekendDayCount - publicHolidaysCount - 25 - daysWorked))/1000;    
        }
        else{
          return 0;
        }
      }
    },
    {_id:35, country:'lu', display:'Congés payés', isRemote:false, isManual:false, period:[1,12], isAcquiredYearly:true, yearLimitTransfer:0, description:'26 jours par an. Acquisition le 1er jour de l\'année ou au prorata.',
      formula:function(year, month, user, publicHolidays, options){
          let daysAcquired = 26;
          let isRecruitedThisYear = new Date(user.recruitmentDate).getFullYear()==year && new Date(user.recruitmentDate).getMonth()==month;
          let isDepartureThisYear = user.departureDate && new Date(user.departureDate).getFullYear()==year && new Date(user.departureDate).getMonth()>=month;
          
          if(isRecruitedThisYear){
              let startDay = new Date(user.recruitmentDate).getDate();
              let acquiredStartMonth = daysAcquired/12;
              if (startDay>15) {
                  acquiredStartMonth=0
              };

              if (user.departureDate && isDepartureThisYear) {

                  let departureDay = new Date(user.departureDate).getDate();
                  let acquiredDepartureMonth = daysAcquired/12;
                  if (departureDay>15) {
                      acquiredDepartureMonth=0
                  };

                  let countMonths = new Date(user.departureDate).getMonth() - new Date(user.recruitmentDate).getMonth() - 1; 
                  return countMonths*daysAcquired/12 + acquiredStartMonth + acquiredDepartureMonth
              };
              return daysAcquired*(12-month-1)/12 + acquiredStartMonth
          }
          else if(month==0){
              if (user.departureDate && isDepartureThisYear) {
                  let countMonths = new Date(user.departureDate).getMonth() - month;
                  let departureDay = new Date(user.departureDate).getDate();
                  let acquiredDepartureMonth = daysAcquired/12;
                  if (departureDay<16) {
                      acquiredDepartureMonth=0
                  };
                  return daysAcquired*(countMonths/12)+acquiredDepartureMonth
              }
              else{
                  return daysAcquired;    
              }
              
          }
          else{
              return 0;
          }
      }
  },
  {_id:36, country:'lu', display:'Absence exceptionnelle', isRemote:false, isManual:true, period:[1,12], description:'Pas de formule, doivent être validés',
      formula:function(year, month, user, publicHolidays, options){
          return null;
      }
  },
  {_id:38, country:'nl', display:'Exceptional absence with limit', isRemote:false, isManual:true, period:[1,12], yearLimitTransfer:0, description:'No formula, need to be validated. Reset to 0 at the end of the year',
      formula:function(year, month, user, publicHolidays, options){
        return null;
      }
  },
  {_id:37, country:'nl', display:'Exceptional absence', isRemote:false, isManual:true, period:[1,12], description:'No formula, need to be validated',
      formula:function(year, month, user, publicHolidays, options){
        return null;
      }
  },
  {_id:39, country:'ae', 
    display:'Exceptional absence with limit', 
    isRemote:false, 
    isManual:true, 
    period:[1,12], 
    yearLimitTransfer:0, 
    resetTo0BOY:true,
    description:'No formula, need to be validated. Reset to 0 at the end of the year',
      formula:function(year, month, user, publicHolidays, options){
        return null;
      }
  },
  {_id:40, 
    country:'fr', 
    display:'Congés payés avec ancienneté', 
    isRemote:false, 
    isManual:false, 
    period:[6,5], 
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description:'25 jours par an, soit 2.083 jours par mois. + Ancienneté : 5 ans d\'ancienneté : 1 jour, 10 ans d\'ancienneté : 2 jours, 15 ans d\'ancienneté : 3 jours, 20 ans d\'ancienneté : 4 jours, 25 ans d\'ancienneté : 5 jours, 30 ans d\'ancienneté : 6 jours',
      formula:function(year, month, user, publicHolidays, options){
          const daysPerYear = 25;
          if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
            return firstMonthRatioCalendar(user, year, month, daysPerYear);
          }  
          
          const months = countMonths(user.recruitmentDate, new Date(year, month+1, 0)) - 1
          var years = Math.floor(months/12);
          var seniority = Math.floor(years/5)
          if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
            return lastMonthRatioCalendar(user, year, month, daysPerYear + (seniority>4?4:seniority));
          }

          return 1 * (25/12) + (seniority>4?4:seniority)/12;
      }
  },
  {_id:41, 
    country:'fr', 
    display:'Congés payés stagiaire', 
    isRemote:false, 
    isManual:false, 
    period:[6,5], 
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description:'2 jours par mois',
      formula:function(year, month, user, publicHolidays, options){
          const daysPerMonth = 2;
          if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {          
            return firstMonthRatioCalendar(user, year, month, daysPerMonth*12);
          }  
          if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
            return lastMonthRatioCalendar(user, year, month, daysPerMonth*12);
          }
          return daysPerMonth;
      }
  },
  {_id:42, country:'de', 
  display:'Working student leave', 
  isRemote:false, 
  isManual:false, 
  period:[1,12], 
  isDay1Start:true, 
  prorataFM:'Prorata based on calendar days',
  prorataLM:'Prorata based on calendar days',
  description:'8 days per year (0.67 days per month).',
      formula:function(year, month, user, publicHolidays, options){
        const daysPerYear = 8;
        if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
          return firstMonthRatioCalendar(user, year, month, daysPerYear);
        }  
        if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
          return lastMonthRatioCalendar(user, year, month, daysPerYear);
        }
          return 1 * (daysPerYear/12);
      }
  },
  {
    _id: 43,
    country: 'de',
    display: 'Leave with first month ratio',
    isRemote: false,
    isManual: false,
    period: [1, 12],
    isDay1Start: true,
    prorataFM:'Prorata based on calendar days + if decimal > 0.5 round up, if 0.25 <= decimal <= 0.5 round to 0.5 else round down',
    prorataLM:'Prorata based on calendar days',
    description: '30 days per year (2.5 days per month).',
    formula(year, month, user, publicHolidays, options) {
      const daysPerYear = 30;
      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        let result = firstMonthRatioCalendar(user, year, month, daysPerYear);

        const decimal = (result - Math.floor(result));
        if(decimal>0.5) return Math.ceil(result);
        if(decimal>=0.25) return Math.floor(result) + 0.5;
        return Math.floor(result);
      }
      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, daysPerYear);
      }
      const suspensionRatio = suspensionPeriodRatioCalendar(year, month, options.period);

      return 1 * (daysPerYear / 12) * suspensionRatio;
    },
  },
  {_id:44, 
    country: 'uk', 
    display:'Paid leave 26 days after 2025, 25 before 2025', 
    isRemote:false, 
    isManual:false, 
    period:[1,12], 
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description:'26 days per year (2.167 days per month) after 2025, 25 days per year (2.083 days per month) before 2025. No acquisition during leave of absence.',
      formula:function(year, month, user, publicHolidays, options){
        var daysPerYear = year<2025?25:26;
          if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
            return firstMonthRatioCalendar(user, year, month, daysPerYear);
          }  
          if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
            return lastMonthRatioCalendar(user, year, month, daysPerYear);
          }
          const LOARatio = LOARatioCalendar(year, month, user);
          return 1 * (daysPerYear/12) * LOARatio;
      }
  },
  {_id:45, 
    country:'in', 
    display:'Leave', 
    isRemote:false, 
    isManual:false, 
    period:[1,12], 
    isDay1Start:true, 
    yearLimitTransfer:5, 
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description:'25 days per year, (2.083 days per month)',
      formula:function(year, month, user, publicHolidays, options){
        const daysPerYear = 25;
        if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
          return firstMonthRatioCalendar(user, year, month, daysPerYear);
        }  

        if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
          return lastMonthRatioCalendar(user, year, month, daysPerYear);
        }

        return 1 * (daysPerYear/12);
      }
  },
  {
    _id: 46,
    country: 'ma',
    display: 'Congés payés 24j avec ancienneté J-D',
    isRemote: false,
    isDay1Start: true,
    isManual: false,
    period: [7, 6],
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description: '2 jours par mois. Ancienneté : 5 ans : 1,5 jour, 10 ans : 3 jours, 15 ans : 4,5 jours, 20 ans : 6 jours, 25 ans : 7,5 jours, 30 ans : 9 jours',
    formula(year, month, user, publicHolidays, options) {

      if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
        return firstMonthRatioCalendar(user, year, month, 24);
      } 

      const months = countMonths(user.recruitmentDate, new Date(year, month+1, 0)) - 1
      const years = Math.floor(months / 12)
      const recruitementMonth = new Date(user.recruitmentDate).getMonth()
      const seniority = recruitementMonth == month ? (1.5 * Math.floor(((years - (years % 5)) / 5))) : 0

      if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
        return lastMonthRatioCalendar(user, year, month, (2 + seniority)*12);
      }

      return 2 + seniority
    },
  },
  {_id:47, 
    country:'fr', 
    display:'JNT Temps partiel après 2025 et 2026', isRemote:false, isManual:false, period:[1,12], isAcquiredYearly:true, resetTo0BOY:true, description:'A partir de 2025 : nombre de jours non travaillés. 2026 : ajout de la perte des JNT mulitipliés par le taux de présence',
      formula(year, month, user, publicHolidays, options){
          let daysInYear = getDaysInYear(year);
          let weekendDayCount = getWeekendDaysInYear(year);
          let publicHolidaysCount = 0;
          let daysWorked = 218;

          let rate = 100
          const job1 = getJobInPeriod(user, new Date(year, month, 1))
          const thisDate = new Date(year, month + 1, 1)
          thisDate.setDate(thisDate.getDate() - 1)

          const job2 = getJobInPeriod(user, thisDate)
          const job = job1 || job2
          if (job && job.rate && job.rate > 0){
            rate = job.rate
          }

          const daysWorkedPartTime = Math.round(daysWorked * rate/100);

          if (year==2025) {
            if(month==0){
              return 218-daysWorkedPartTime;    
            }
            else{
              return 0;
            }
          }
          else if(year>=2026){
            for (var i = 0; i < publicHolidays.length; i++) {
              if (new Date(publicHolidays[i]).getDay()!=0 && new Date(publicHolidays[i]).getDay()!=6) {
                publicHolidaysCount++;
              };
            };
            const JNT = Math.round(1000 * 1 * (daysInYear - weekendDayCount - publicHolidaysCount - 25 - daysWorked))/1000;    
            if(month==0){
              return 218 - daysWorkedPartTime + ((100-rate)/100)*JNT;
            }
            else{
              return 0;
            }
          }
          else{
            return 0;
          }
      }
    },
    {_id:48, country:'fr', display:'RTT au 1er janvier', isRemote:false, isManual:false, period:[1,12], isAcquiredYearly:true, description:'nombre de jours dans l\'année - (nombre de samedis + nombre de dimanches + nombre de jours fériés en semaine + 25 jours de congés payés + 218 jours travaillés).',
      formula(year, month, user, publicHolidays, options){
          let daysInYear = getDaysInYear(year);
          let weekendDayCount = getWeekendDaysInYear(year);
          let publicHolidaysCount = 0;
          let daysWorked = 218;
          
          let rate = 100;
          const job1 = getJobInPeriod(user, new Date(year, month, 1))
          const thisDate = new Date(year, month + 1, 1)
          thisDate.setDate(thisDate.getDate() - 1)

          const job2 = getJobInPeriod(user, thisDate)
          const job = job1 || job2
          if (job && job.rate && job.rate > 0){
            rate = job.rate
          }

          daysWorked = Math.round(daysWorked * rate/100);
          

          for (var i = 0; i < publicHolidays.length; i++) {
              if (new Date(publicHolidays[i]).getDay()!=0 && new Date(publicHolidays[i]).getDay()!=6) {
                  publicHolidaysCount++;
              };
          };

          if(month==0){
              return Math.round(1000 * 1 * (daysInYear - weekendDayCount - publicHolidaysCount - 25 - daysWorked))/1000;    
          }
          else{
              return 0;
          }
      }
    },
    {_id:49, 
      country:'fr', 
      display:'Congés payés avec ancienneté à juin en jours calendaires', 
      isRemote:false, 
      isManual:false, 
      period:[6,5], 
      prorataFM:'Prorata based on 30 days/month',
      prorataLM:'Prorata based on 30 days/month',
      description:'25 jours par an, soit 2.083 jours par mois. + Ancienneté à partir de juin : 5 ans d\'ancienneté : 1 jour, 10 ans d\'ancienneté : 2 jours, 15 ans d\'ancienneté : 3 jours, 20 ans d\'ancienneté : 4 jours, 25 ans d\'ancienneté : 5 jours, 30 ans d\'ancienneté : 6 jours',
      formula:function(year, month, user, publicHolidays, options){
            const daysPerYear = 2.08*12;

            const suspensionRatio = suspensionPeriodRatioCalendar(year, month, options.period);

            const earliestStartDate = new Date(user.earliestStartDate || user.recruitmentDate);
          
            if (new Date(earliestStartDate).getFullYear() == year && new Date(earliestStartDate).getMonth() == month && new Date(earliestStartDate).getDate()>1) {
              return suspensionRatio * Math.ceil(firstMonthRatio30(user, year, month, daysPerYear) * 100) / 100;
            }  

            var months = countMonths(earliestStartDate, new Date(year, month+1, 0)) - 1

            var years = Math.floor(months/12);

            if(years%5==0 && month<5){
              years=years-1;
            }
            var seniority = Math.floor(years/5)

            seniority = (seniority>4?4:seniority)

            if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
              // calculer prorata
              return suspensionRatio * Math.round(lastMonthRatio30(user, year, month, daysPerYear + seniority) * 100) / 100;
            }

            return suspensionRatio * (daysPerYear/12) + (month==5?seniority:0);
        },
        endBalanceFormula:function({month, balance}){
          if(month==4){         
            const previousBalance = balance.endBalance - (balance.periodCumulatedAcquired ?? 0) + (balance.periodCumulatedTaken ?? 0);
            // console.log('previousBalance', previousBalance)
            balance.endBalance = Math.ceil(balance.periodCumulatedAcquired ?? 0)  - (balance.periodCumulatedTaken ?? 0) + previousBalance;
          }
          return balance ?? null;
        }
    },
    {_id:50, 
      country: 'uk', 
      display:'Paid leave 30 days', 
      isRemote:false, 
      isManual:false, 
      period:[1,12], 
      prorataFM:'Prorata based on calendar days',
      prorataLM:'Prorata based on calendar days',
      description:'30 days per year (2.5 days per month)',
      formula:function(year, month, user, publicHolidays, options){
          var daysPerYear = 30;
            if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
              return firstMonthRatioCalendar(user, year, month, daysPerYear);
            }  
            if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
              return lastMonthRatioCalendar(user, year, month, daysPerYear);
            }
            const LOARatio = LOARatioCalendar(year, month, user);
            return 1 * (daysPerYear/12) * LOARatio;
        }
    },
    {_id:51, 
      country:'fr', 
      display:'Congés payés avec ancienneté à juin en jours ouvrés', 
      isRemote:false, 
      isManual:false, 
      period:[6,5], 
      prorataFM:'Prorata based on business days',
      prorataLM:'Prorata based on business days',
      description:'25 jours par an, soit 2.083 jours par mois. + Ancienneté à partir de juin : 5 ans d\'ancienneté : 1 jour, 10 ans d\'ancienneté : 2 jours, 15 ans d\'ancienneté : 3 jours, 20 ans d\'ancienneté : 4 jours, 25 ans d\'ancienneté : 5 jours, 30 ans d\'ancienneté : 6 jours',
      formula:function(year, month, user, publicHolidays, options){
            const daysPerYear = 25;
            if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
              const acq = firstMonthRatioBusiness(user, year, month, daysPerYear, []);
              return Math.floor(acq * 100) / 100;
            }  
            
            var months = countMonths(user.recruitmentDate, new Date(year, month+1, 0)) - 1

            var years = Math.floor(months/12);

            if(years%5==0 && month<5){
              years=years-1;
            }
            var seniority = Math.floor(years/5)

            seniority = (seniority>4?4:seniority)

            if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
              // calculer prorata
              return lastMonthRatioBusiness(user, year, month, daysPerYear + seniority, []);
            }
  
            return 1 * (daysPerYear/12) + (month==5?seniority:0);
        }
    },
  {
    _id: 52,
    country: 'es',
    display: 'Exceptional absence with reset to 0 EOY',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'No formula, need to be validated. Each year balance is reset to 0.',
    resetTo0BOY:true,
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
   {
    _id: 53,
    country: 'de',
    display: 'Absence with acquisition suspension',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    noAcquisitionsAfterWeek:14,
    description: 'Exceptional absence that sets all acquisitions to 0 after 14 weeks',
    formula(year, month, user, publicHolidays, options) {
      return null
    }
  },
  {_id:54, 
    country:'au', 
    display:'Personal leave', 
    isRemote:false, 
    isHours:true,
    isManual:false, 
    period:[1,12], 
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description:'76 hours per year',
      formula:function(year, month, user, publicHolidays, options){
        const hoursPerYear = 76;
        if (new Date(user.recruitmentDate).getFullYear() == year && new Date(user.recruitmentDate).getMonth() == month && new Date(user.recruitmentDate).getDate()>1) {
          return firstMonthRatioCalendar(user, year, month, hoursPerYear);
        }  
        if (user.departureDate && new Date(user.departureDate).getFullYear() == year && new Date(user.departureDate).getMonth() == month) {
          return lastMonthRatioCalendar(user, year, month, hoursPerYear);
        }

        const countWeekDaysInMonth = workingDaysBetweenDates(new Date(year, month, 1), new Date(year, month + 1, 0));
        const excludedDays = getExcludedWeekDays(year, month, options.excludedDays)
        const workedDays = countWeekDaysInMonth - excludedDays;
        const acquiredWorkedDays = workedDays * (hoursPerYear / 12 / workedDays)

        return excludedDays===0 ? (hoursPerYear/12) : acquiredWorkedDays ;

      }
  },
  {
    _id: 55,
    country: 'es',
    display: 'Exceptional absence with no acquisition',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'No formula, need to be validated. No acquisition during the leave.',
    noAcquisitionsAfterWeek:0,
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 56,
    country: 'au',
    display: 'Exceptional absence with no acquisition',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'No formula, need to be validated. No acquisition during the leave.',
    excludeAcquisition:true,
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 57,
    country: 'es',
    display: 'Exceptional absence with reset to 0 EOY and no acquisition',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'No formula, need to be validated. Each year balance is reset to 0. No acquisition during the leave.',
    noAcquisitionsAfterWeek:0,
    resetTo0BOY:true,
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 58,
    country: 'fr',
    display: 'Absence exceptionnelle sans acquisition',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'Pas de formule, doivent être validés',
    noAcquisitionsAfterWeek:0,
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {_id:59, 
    country:'cn', 
    display:'CN Annual Leave 20 days', 
    isRemote:false, 
    isManual:false, 
    period:[1,12], 
    yearLimitTransfer:2, 
    isAcquiredYearly:true, 
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description:'20 days per year',
      formula:function(year, month, user, publicHolidays, options){
        const daysPerYear = 20;
        
        var result = yearlyAcquisition(year, month, user, publicHolidays.map(el=>new Date(el)), daysPerYear);
        return Math.ceil(result*2)/2;
      }
  },
  {_id:60, 
    country:'cn', 
    display:'CN Annual Leave 15 days', 
    isRemote:false, 
    isManual:false, 
    period:[1,12], 
    yearLimitTransfer:2, 
    isAcquiredYearly:true, 
    prorataFM:'Prorata based on calendar days',
    prorataLM:'Prorata based on calendar days',
    description:'15 days per year',
      formula:function(year, month, user, publicHolidays, options){
        const daysPerYear = 15;

        var result = yearlyAcquisition(year, month, user, publicHolidays.map(el=>new Date(el)), daysPerYear);
        return Math.ceil(result*2)/2;

      }
  },
  {
    _id: 61,
    country: 'au',
    display: 'Compassionate leave',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    resetTo0BOY:true,
    description: 'Maximum of 2 days per year.',
    formula(year, month, user, publicHolidays, options) {
      const earliestStartDate = new Date(user.earliestStartDate || user.recruitmentDate);
      if(month==0 || (month==earliestStartDate.getMonth() && year==earliestStartDate.getFullYear())){
        return 2;
      }
      return 0;
    },
  },
  {
    _id: 62,
    country: 'cn',
    display: 'Exceptional absence',
    isRemote: false,
    isManual: true,
    period: [1, 12],
    description: 'No formula, need to be validated.',
    formula(year, month, user, publicHolidays, options) {
      return null
    },
  },
  {
    _id: 63,
    country: 'fr',
    display: 'Congés d\'ancienneté SYNTEC',
    isRemote: false,
    isManual: false,
    period: [6, 5],
    description: 'Acquisition le mois de mai suivant l\'anniversaire. 5 ans d\'ancienneté : 1 jour, 10 ans d\'ancienneté : 2 jours, 15 ans d\'ancienneté : 3 jours, 20 ans d\'ancienneté : 4 jours, 25 ans d\'ancienneté : 5 jours, 30 ans d\'ancienneté : 6 jours',
    formula(year, month, user, publicHolidays, options) {
      const months = countMonths(user.recruitmentDate, new Date(year, month+1, 0)) - 1
      const years = Math.floor(months / 12)

      return month==4?Math.floor(years/5):0;
    },
  }
]
